
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $yhhhl = parcelRequire("yhhhl");

var $ix1ma = parcelRequire("ix1ma");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-c3f06c7885";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $be9c067c7be4fda0$var$BASE_URL = "https://www.atlassian.com";
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const page = /*#__PURE__*/ (0, $dypTs.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                        rel: "canonical",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                        rel: "alternate",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $dypTs.jsx)("link", {
                            rel: "alternate",
                            href: `${$be9c067c7be4fda0$var$BASE_URL}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $ix1ma.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $ix1ma.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment !== null && $36b5b9e576032b2f$var$clientSideRelayEnvironment !== void 0 ? $36b5b9e576032b2f$var$clientSideRelayEnvironment : $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("hVRZ8", function(module, exports) {
$parcel$export(module.exports, "AgileOverviewPage", function () { return $dc56e2f2cc0fd211$export$be1de7c01f2a75bf; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $f3gS9 = parcelRequire("f3gS9");

var $20OkY = parcelRequire("20OkY");

var $lFwc0 = parcelRequire("lFwc0");

var $bv77X = parcelRequire("bv77X");

var $7I0bM = parcelRequire("7I0bM");

var $5shys = parcelRequire("5shys");

var $ad11P = parcelRequire("ad11P");
const $dc56e2f2cc0fd211$export$be1de7c01f2a75bf = ({ agileOverview: agileOverview, queryRef: queryRef, location: location })=>{
    var _dataPartOne_micrositeTopicOverviewCollection, _dataPartTwo_micrositeTopicOverviewCollection;
    const dataPartOne = (0, $f3gS9.usePreloadedQuery)((0, $7I0bM.AgileOverviewOneQuery), queryRef);
    const dataPartTwo = (0, $f3gS9.useLazyLoadQuery)((0, $7I0bM.AgileOverviewTwoQuery), (0, $7I0bM.getAgileOverviewQueryVars)(location));
    const combinedData = {
        micrositeTopicOverviewCollection: {
            items: [
                (0, $6ogO3._)({}, (_dataPartOne_micrositeTopicOverviewCollection = dataPartOne.micrositeTopicOverviewCollection) === null || _dataPartOne_micrositeTopicOverviewCollection === void 0 ? void 0 : _dataPartOne_micrositeTopicOverviewCollection.items[0], (_dataPartTwo_micrositeTopicOverviewCollection = dataPartTwo.micrositeTopicOverviewCollection) === null || _dataPartTwo_micrositeTopicOverviewCollection === void 0 ? void 0 : _dataPartTwo_micrositeTopicOverviewCollection.items[0])
            ]
        }
    };
    agileOverview = (0, $7I0bM.shapeAgileOverviewContentfulResponse)(combinedData);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bv77X.SitesContextProvider), {
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $lFwc0.SiteSelectorContextProvider), {
            analyticsPrefix: "jira-software.ondemand" // TODO: Check if this is correct
            ,
            productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $ad11P.AgileOverviewProvider), {
                agileOverview: agileOverview,
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5shys.AgileOverviewPageTemplate), {})
            })
        })
    });
};

});
parcelRegister("5shys", function(module, exports) {
$parcel$export(module.exports, "AgileOverviewPageTemplate", function () { return $8504dfe6b198685c$export$22da6a544e7c9853; });
/* agile-overview-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $4EfnG = parcelRequire("4EfnG");

var $jMhSx = parcelRequire("jMhSx");

var $4Xs4O = parcelRequire("4Xs4O");

var $76zkt = parcelRequire("76zkt");

var $l2QYX = parcelRequire("l2QYX");

var $glBbF = parcelRequire("glBbF");

var $ad11P = parcelRequire("ad11P");

var $82TGg = parcelRequire("82TGg");

var $fUC0C = parcelRequire("fUC0C");

var $10T7A = parcelRequire("10T7A");

var $1PkHM = parcelRequire("1PkHM");

var $4hXrx = parcelRequire("4hXrx");

var $2TQtV = parcelRequire("2TQtV");

var $7ESW0 = parcelRequire("7ESW0");

var $1Enm0 = parcelRequire("1Enm0");
// Override Row layout to keep sidenav and content inline
// FIXME: These nested selectors are hacks to components we own
const $8504dfe6b198685c$var$rowWrapperCss = null;
const $8504dfe6b198685c$var$mainContentCss = null;
const $8504dfe6b198685c$export$22da6a544e7c9853 = ()=>{
    const agileOverviewData = (0, $ad11P.useAgileOverview)();
    if (!agileOverviewData) return null;
    return /*#__PURE__*/ (0, $dypTs.jsx)($8504dfe6b198685c$var$AgileOverviewPageTemplateContent, (0, $6ogO3._)({}, agileOverviewData));
};
const $8504dfe6b198685c$var$AgileOverviewPageTemplateContent = (props)=>{
    var _props_author, _props_author1, _props_author_authorPicture, _props_author2, _props_author_authorPicture1, _props_author3;
    const agileHeroProps = {
        headerText: props.title,
        secondaryText: props.subtitle || "",
        backgroundPicture: props.bannerImage
    };
    const agileAuthorProps = {
        name: (_props_author = props.author) === null || _props_author === void 0 ? void 0 : _props_author.name,
        biography: (_props_author1 = props.author) === null || _props_author1 === void 0 ? void 0 : _props_author1.shortBiography,
        pictureSrc: (_props_author2 = props.author) === null || _props_author2 === void 0 ? void 0 : (_props_author_authorPicture = _props_author2.authorPicture) === null || _props_author_authorPicture === void 0 ? void 0 : _props_author_authorPicture.url,
        contentType: (_props_author3 = props.author) === null || _props_author3 === void 0 ? void 0 : (_props_author_authorPicture1 = _props_author3.authorPicture) === null || _props_author_authorPicture1 === void 0 ? void 0 : _props_author_authorPicture1.contentType
    };
    const agileCardsProps = (0, $4hXrx.useCardProps)((props === null || props === void 0 ? void 0 : props.featuredContentContainer) || []);
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.default), {
                isShowTryNowLink: true,
                tryNowLinkCtaButtonColor: "blue",
                productKey: "agile"
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $glBbF.default), {
                selectedNavLink: "agile"
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)((0, $4EfnG.default), {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $10T7A.AgileHero), (0, $6ogO3._)({}, agileHeroProps)),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1iqz17cv _a2cwzg3v _1yzi1g6w _11fhglyw _16qs1qj0 _1q51zwfg _85i5ckbl"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
                            layout: "3-9",
                            alignItems: "top",
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)((0, $76zkt.AgileHubSideNav), {
                                    nodes: (0, $1Enm0.useAgileHubPageTreeData)()
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_14611g6w _f0zu1nbp _dzjezg3v _1xpq1nbp"
                                    ]),
                                    children: [
                                        props.mainCallToAction && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2TQtV.ProductCTA), (0, $6ogO3._)({
                                            name: "Kanban"
                                        }, props.mainCallToAction)),
                                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $1PkHM.AgileOverviewMainContent), {
                                            topicOverviewData: props
                                        }),
                                        props.author && /*#__PURE__*/ (0, $dypTs.jsx)((0, $82TGg.AgileAuthor), (0, $6ogO3._)({}, agileAuthorProps)),
                                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_181nglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $fUC0C.AgileCards), {
                                                headerText: props.name,
                                                cardsProps: agileCardsProps
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $4hXrx.NavigationCards), {
                        cardsData: props.nextBestAction
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $7ESW0.ShareUpNextBar), {
                        nodes: (0, $1Enm0.useAgileHubPageTreeData)(),
                        title: props.title,
                        description: props.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $4Xs4O.default), {})
        ]
    });
};

});
parcelRegister("glBbF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46b03e8ba0851f09$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $lzfAX = parcelRequire("lzfAX");

var $kooLp = parcelRequire("kooLp");
const $46b03e8ba0851f09$export$3114ed03a2c45c8b = ({ selectedNavLink: selectedNavLink })=>{
    const intl = (0, $8e22h.default)();
    const devopsDropdown = [
        {
            header: "",
            hideHeader: true,
            items: [
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.delivery",
                        defaultMessage: "Continuous Delivery"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/continuous-delivery"),
                    isSelected: selectedNavLink === "continuousDelivery"
                },
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.git",
                        defaultMessage: "Git"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/git"),
                    isSelected: selectedNavLink === "git"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $lzfAX.ProductNavBar), {
        productHref: (0, $kooLp.useLocalizedHref)("/software-development"),
        productName: "softwaredevelopment",
        ariaLabel: intl.formatMessage({
            id: "SoftwareDevelopmentProductNav.logo-label",
            defaultMessage: "Software Development"
        }),
        showTextWithoutLogo: true,
        showFreeHrefButton: false,
        dataProductKey: "softwareDevelopment",
        logoLinkWrapperWidth: "max-content",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $lzfAX.ProductNavDropdown), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.dropdown.devops",
                    defaultMessage: "DevOps"
                }),
                groups: devopsDropdown
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $lzfAX.ProductNavLink), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.agile",
                    defaultMessage: "Agile"
                }),
                href: (0, $kooLp.useLocalizedHref)("/agile"),
                isSelected: selectedNavLink === "agile"
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $lzfAX.ProductNavLink), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.microservices",
                    defaultMessage: "Microservices"
                }),
                href: (0, $kooLp.useLocalizedHref)("/microservices"),
                isSelected: selectedNavLink === "microservices"
            })
        ]
    });
};
var $46b03e8ba0851f09$export$2e2bcd8739ae039 = $46b03e8ba0851f09$export$3114ed03a2c45c8b;

});

parcelRegister("ad11P", function(module, exports) {
$parcel$export(module.exports, "AgileOverviewProvider", function () { return $bab7f7e089c6067a$export$45b81a39c29b3e59; });
$parcel$export(module.exports, "useAgileOverview", function () { return $bab7f7e089c6067a$export$809688ba543042f1; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $4U3Z4 = parcelRequire("4U3Z4");

var $df0Hj = parcelRequire("df0Hj");

var $9NffS = parcelRequire("9NffS");
const $bab7f7e089c6067a$export$bb3d35787c3373e0 = /*#__PURE__*/ (0, $gljCV.createContext)(null);
const $bab7f7e089c6067a$var$useAgileOverviewContextValue = (agileOverview)=>{
    const [contextValue, setContextValue] = (0, $gljCV.useState)(agileOverview);
    (0, $gljCV.useEffect)(()=>{
        const fetchAgileOverviewFromClient = async ()=>{
            const client = new (0, $9NffS.AGGClient)({
                gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
            });
            const { route: route, locale: locale } = (0, $df0Hj.getCurrentRoute)();
            const agileOverview = await (0, $4U3Z4.getTemplateData)(route, locale, client);
            setContextValue(agileOverview);
        };
        if (!contextValue) fetchAgileOverviewFromClient();
    // empty dependency array so this effect only runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return contextValue;
};
const $bab7f7e089c6067a$export$45b81a39c29b3e59 = (props)=>{
    const value = $bab7f7e089c6067a$var$useAgileOverviewContextValue(props.agileOverview);
    return /*#__PURE__*/ (0, $dypTs.jsx)($bab7f7e089c6067a$export$bb3d35787c3373e0.Provider, {
        value: value,
        children: props.children
    });
};
const $bab7f7e089c6067a$export$809688ba543042f1 = ()=>{
    const agileOverview = (0, $gljCV.useContext)($bab7f7e089c6067a$export$bb3d35787c3373e0);
    if (!agileOverview) console.warn("SSR failed to fetch content on the server. Fetching content on the client.");
    return agileOverview;
};

});

parcelRegister("fUC0C", function(module, exports) {
$parcel$export(module.exports, "AgileCards", function () { return $55d916ed3f2a88a4$export$8d784affd4fac712; });
/* agile-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $4hXrx = parcelRequire("4hXrx");
const $55d916ed3f2a88a4$export$8d784affd4fac712 = ({ headerText: headerText, cardsProps: cardsProps })=>{
    const containerCSS = null;
    const headerCSS = null;
    const cardCSS = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0q7vkz _u5f37vkz _n3td7vkz _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_syaz1bqd _1wyb1k8s _vwz415sy _6rth7vkz _1pfhidpf _1dyznl7k _k48pbfng"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                    id: "AgileOverview.AgileCards.Card.Header",
                    defaultMessage: "{headerText} featured content",
                    values: {
                        headerText: headerText
                    },
                    description: "headerText is an agile concept such as Kanban, Agile project management, Design, etc."
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _ahbq1h22 _12l21h22 _1q517vkz _85i57vkz _syaz1bqd _1qeivwuj _1qef1crf _1adhl8b6 _bsma1tcg _crcvangw _15jft94y _q2dt1td8 _qliy1bqd _1biu1j8p _3tur1osq _yk5jh9n0 _3cbl1osq _1p94idpf _d47fidpf _1qv9idpf _d600idpf"
                ]),
                children: cardsProps.map((props)=>{
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsbx683 _i0dlx683 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1cgj1y44 _10gg14ds _12rr1ssb _16xt1ssb _1rfm1osq _1a1x1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $gljCV.createElement)((0, $4hXrx.NavigationCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                            key: `${props.headerText}-body-card`
                        }))
                    }, `${props.headerText}-body-card-container`);
                })
            })
        ]
    });
};

});

parcelRegister("10T7A", function(module, exports) {
$parcel$export(module.exports, "AgileHero", function () { return $b69f4a6e8b2273f6$export$9df2733b25de56ba; });
/* agile-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5HK05 = parcelRequire("5HK05");
const $b69f4a6e8b2273f6$export$9df2733b25de56ba = ({ headerText: headerText, secondaryText: secondaryText, backgroundPicture: backgroundPicture })=>{
    const heroCss = null;
    const headerCss = null;
    const secondaryCss = null;
    const capitalize = (title)=>{
        return title.charAt(0).toUpperCase() + title.slice(1);
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gn1h6o _1itk10ch _ouxl1ssb _1lrw1dfr _12vemgnk _ahbq1wug _12l21wug _1q51vbgk _85i5vbgk _bozg7vkz _y4ti7vkz _1ul91osq _11rm1hrf _syazu67f"
        ]),
        style: {
            "--_13fp5a": (0, $6ZVlx.default)((0, $5HK05.expectContent)(backgroundPicture).url, ")", "url(")
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_k48p1nn1 _1wybviql _1pfh7vkz _6rth7vkz _ahbqidpf _12l2idpf _1dyzidpf _vwz4zz36 _1s18yn4p _fz891wto"
                ]),
                children: capitalize((0, $5HK05.expectContent)(headerText))
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb1k92 _ect4kipj _1dyznl7k _vwz419ii _k48p1kze _6rth7vkz"
                ]),
                children: secondaryText
            })
        ]
    });
};

});

parcelRegister("1PkHM", function(module, exports) {
$parcel$export(module.exports, "AgileOverviewMainContent", function () { return $589aae9f9551a6cf$export$97937ae50eb0879; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $fUC0C = parcelRequire("fUC0C");

var $4hXrx = parcelRequire("4hXrx");

var $7tb7q = parcelRequire("7tb7q");

var $aVsay = parcelRequire("aVsay");
const $589aae9f9551a6cf$var$readOnBelowCss = null;
const $589aae9f9551a6cf$var$continuedCss = null;
// FIXME: These styles seem like they are in the wrong place. Shouldn't they be in the rich text component?
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ const $589aae9f9551a6cf$var$mainContentWrapperCss = null;
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */ const $589aae9f9551a6cf$var$ReadOnBelow = ()=>{
    const handleClick = (e)=>{
        var _document_getElementById;
        e.preventDefault();
        (_document_getElementById = document.getElementById("continued")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
            href: "#continued",
            onClick: handleClick,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "jiraSoftware",
            className: (0, $2jatx.default)([
                "_y3gn1h6o _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _kqswh2mm _1e0c1ule _k48p1fw0 _syazvwuj _1wyboxwj _1dyzt94y _vwz410nf _wnkw1ylp _6rthdlk8 _1p1dangw _30l3oelr _sugaglyw"
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                id: "agile.overview.readOnBelow",
                defaultMessage: "Read on below"
            })
        })
    });
};
const $589aae9f9551a6cf$var$Continued = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        id: "continued",
        className: (0, $2jatx.default)([
            "_syazvwuj _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _kqswh2mm _y3gn1h6o _1wyboqnp _vwz4cs5v _1p1dangw _1dyzt94y _sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                id: "agile.overview.continued",
                defaultMessage: "[Continued]"
            })
        })
    });
};
const $589aae9f9551a6cf$export$97937ae50eb0879 = (props)=>{
    var _props_topicOverviewData_bodyTextContainer;
    const TopicIntroductionSection = ()=>{
        const topicIntroductionContent = props.topicOverviewData.topicIntroduction;
        return topicIntroductionContent === null || topicIntroductionContent === void 0 ? void 0 : topicIntroductionContent.map((data, idx)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $aVsay.TopicIntroduction), (0, $6ogO3._)({}, data))
            }, idx));
    };
    const BodyTextContainerSection = ()=>{
        const bodyTextContent = props.topicOverviewData.bodyTextContainer;
        return bodyTextContent === null || bodyTextContent === void 0 ? void 0 : bodyTextContent.map((data, idx)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $7tb7q.BodyTextContainer), (0, $6ogO3._)({}, data))
            }, idx));
    };
    const hasBodyText = !!((_props_topicOverviewData_bodyTextContainer = props.topicOverviewData.bodyTextContainer) === null || _props_topicOverviewData_bodyTextContainer === void 0 ? void 0 : _props_topicOverviewData_bodyTextContainer.length);
    const featuredContentCardProps = (0, $4hXrx.useCardProps)(props.topicOverviewData.featuredContentContainer || []);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1dm8q5uf _125x1mpp _q7gq1cby _zcqx14u8 _8v2f19ye _1yzi19ye _160119ye _l5k1bfng _r8ntbfng _1a7kbfng _cg411bqd _qliy1bqd _1rhq1bqd _11eb1k8s _17z415sy _qc0pahaf _ggmh1k92 _1axi11ph _1o6v7vkz _ugctnl7k _1edj1k8s _8kc91k92 _1euycjiy _k6x07vkz _8lldnl7k"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)(TopicIntroductionSection, {}),
            hasBodyText && /*#__PURE__*/ (0, $dypTs.jsx)($589aae9f9551a6cf$var$ReadOnBelow, {}),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $fUC0C.AgileCards), {
                    headerText: props.topicOverviewData.name,
                    cardsProps: featuredContentCardProps
                })
            }),
            hasBodyText && /*#__PURE__*/ (0, $dypTs.jsx)($589aae9f9551a6cf$var$Continued, {}),
            /*#__PURE__*/ (0, $dypTs.jsx)(BodyTextContainerSection, {})
        ]
    });
};

});
parcelRegister("aVsay", function(module, exports) {
$parcel$export(module.exports, "TopicIntroduction", function () { return $530ca755a5fba94b$export$eec80089618278cb; });
/* topic-introduction.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $gtz2R = parcelRequire("gtz2R");

var $imIsw = parcelRequire("imIsw");

var $B5GRx = parcelRequire("B5GRx");
const $530ca755a5fba94b$var$topicIntroductionWrapperCss = null;
const $530ca755a5fba94b$var$headerCss = null;
const $530ca755a5fba94b$var$assetCss = null;
const $530ca755a5fba94b$export$eec80089618278cb = ({ title: title, details: details, embedLink: embedLink, asset: asset })=>{
    const renderIntroductionAsset = ()=>{
        // If there's an embedLink, we expect an asset to go with it.
        if (embedLink && (asset === null || asset === void 0 ? void 0 : asset.length)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
            embedLink: embedLink,
            title: title !== null && title !== void 0 ? title : "",
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            thumbnail: asset[0]
        });
        if (asset) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
            children: asset.map((asset)=>{
                var _asset_url, _asset_description, _ref;
                return /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: (_asset_url = asset === null || asset === void 0 ? void 0 : asset.url) !== null && _asset_url !== void 0 ? _asset_url : "",
                        alt: (_ref = (_asset_description = asset === null || asset === void 0 ? void 0 : asset.description) !== null && _asset_description !== void 0 ? _asset_description : asset === null || asset === void 0 ? void 0 : asset.name) !== null && _ref !== void 0 ? _ref : ""
                    }
                }, asset === null || asset === void 0 ? void 0 : asset.name);
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1ule _kqswh2mm _4t3i1osq _1q517vkz",
            "topicIntroduction"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthjbgo _1pfh7vkz"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: "topicIntroduction-body",
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                    text: details,
                    name: null
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _kqswh2mm",
                    "topicIntroduction-asset"
                ]),
                children: renderIntroductionAsset()
            })
        ]
    });
};

});
parcelRegister("gtz2R", function(module, exports) {
$parcel$export(module.exports, "AgileVideo", function () { return $77a9052cb39a9ac9$export$a01c1a169afc755c; });
/* agile-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $77a9052cb39a9ac9$var$PlayIcon = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        className: (0, $2jatx.default)([
            "_lswucd5j _tzy4q80t _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $77a9052cb39a9ac9$export$a01c1a169afc755c = (props)=>{
    const { embedLink: embedLink, title: title, thumbnail: thumbnail } = props;
    const [isPlaying, setIsPlaying] = (0, $gljCV.useState)(false);
    const bgImage = `url("${thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url}")`;
    const videoOverlayCss = null;
    const iFrameCss = null;
    const videoDataEventProps = {
        "data-product-key": "jiraSoftware",
        "data-event-component": "linkButton",
        "data-event-container": "videoEmbedInline",
        "data-event": "clicked"
    };
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
    };
    const VideoSection = ()=>{
        const isIFrame = embedLink.includes("iframe");
        if (isIFrame) return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: embedLink
            },
            className: (0, $2jatx.default)([
                "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
            ])
        });
        else return /*#__PURE__*/ (0, $dypTs.jsx)("iframe", {
            width: "100%",
            height: "auto",
            src: $77a9052cb39a9ac9$var$addAutoplay(embedLink),
            title: title,
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
            allowFullScreen: true,
            "data-gtm-yt-inspected-12": "true",
            className: (0, $2jatx.default)([
                "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev"
            ])
        });
        return null;
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            !isPlaying && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1reo15vq _18m915vq _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("button", (0, $dPABA._)((0, $6ogO3._)({
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq",
                        "play-trigger"
                    ]),
                    onClick: handleClick
                }, videoDataEventProps), {
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("img", {
                            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC",
                            alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.name,
                            className: (0, $2jatx.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _irr3cd5j _1llw1vf8"
                            ]),
                            style: {
                                "--_um3idz": (0, $6ZVlx.default)(bgImage),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($77a9052cb39a9ac9$var$PlayIcon, {})
                    ]
                }))
            }),
            isPlaying && /*#__PURE__*/ (0, $dypTs.jsx)(VideoSection, {})
        ]
    });
};
const $77a9052cb39a9ac9$var$addAutoplay = (url)=>{
    if (url.includes("?")) return `${url}&autoplay=1`;
    else return `${url}?autoplay=1`;
};

});

parcelRegister("B5GRx", function(module, exports) {
$parcel$export(module.exports, "RichTextComponent", function () { return $ce64332389313a44$export$f7b0c3f1955f2d70; });
/* body-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $kooLp = parcelRequire("kooLp");
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $ce64332389313a44$var$richTextCss = null;
const $ce64332389313a44$export$f7b0c3f1955f2d70 = (data)=>{
    const localeCode = (0, $kooLp.useLocale)();
    const html = (0, $gljCV.useMemo)(()=>{
        let initialHtml = data.text || "";
        // Hacky stuff: Need to wrap tables in a div to make them scrollable
        const tableRegex = /<table[^>]*>[\s\S]*?<\/table>/g;
        const tableMatch = initialHtml.match(tableRegex);
        if (tableMatch) {
            const tableHtml = tableMatch[0];
            const newTableHtml = `<div class="table-wrapper">${tableHtml}</div>`;
            initialHtml = initialHtml.replace(tableHtml, newTableHtml);
        }
        // Hacky stuff pt2: Need to fix relative localized links
        const relativeLinkRegex = RegExp('(?:\\"https:\\/\\/\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $kooLp.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        });
        // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, "g");
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If the locale code is already present, return the match as is
            if (_p1) return _match;
            // Otherwise, prepend the locale code to the URL
            return localeCode === (0, $kooLp.DEFAULT_LOCALE) ? `href="/${_p2}"` : `href="/${localeCode}/${_p2}"`;
        });
        // handle case where absolute WAC links are not localized
        const absolutePathRegex = RegExp('\\"https:\\/\\/www\\.atlassian\\.com\\/(?![a-z]{2}\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $kooLp.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        });
        // Hacky stuff pt3: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, "&nbsp;").replace(/&amp;amp;/g, "&amp;");
        return initialHtml;
    }, [
        data.text,
        localeCode
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        },
        className: (0, $2jatx.default)([
            "_q7gq1cby _zcqx1rqn _1v71idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2jj1oc _yb6gnqa1 _2b5et94y _p4li7vkz _owip7vkz _6aut7vkz _1pqw7vkz _134q1ule _1mjs1wug _22rsvbgk _1txxidpf _1gc1idpf _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _2yrbagmp _43dz1u0t _5cr0h2mm _1dg11fu0 _1r7587ef _kbnuzwfg _1mcew6e8 _1frx1u0t _81wzyxqu _ui0gdlk8 _u0rjsusb _1ob3yxqu _1pubidpf _120wstnw _16g612gs _1ghd1h6o _1fhp1j6v _ha8hvwuj _14371k8s _1128bs82 _btqhidpf _1tadidpf _1ejb1tcg _1ahqidpf _172k12u0 _y5iq1lzr _olif1nu9 _r5plvwuj _1ipc1k8s _1yqebs82"
        ])
    });
};

});





parcelRegister("3SU2g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d41e1b70cc0a358$var$_react = $2d41e1b70cc0a358$var$_interopRequireDefault((parcelRequire("gljCV")));

var $klGIk = parcelRequire("klGIk");

var $2d41e1b70cc0a358$var$_chevronDown = $2d41e1b70cc0a358$var$_interopRequireDefault((parcelRequire("5RBBI")));
function $2d41e1b70cc0a358$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2d41e1b70cc0a358$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $2d41e1b70cc0a358$var$_react.default.createElement($klGIk.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $2d41e1b70cc0a358$var$_chevronDown.default
    }));
$2d41e1b70cc0a358$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $2d41e1b70cc0a358$var$_default = module.exports.default = $2d41e1b70cc0a358$var$HipchatChevronDownIcon;

});
parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("gljCV")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});


parcelRegister("HMZ3r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ftgEA")).ContentPlatformImage; });

var $ftgEA = parcelRequire("ftgEA");

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $imIsw = parcelRequire("imIsw");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $aPnCa._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $imIsw.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $dypTs.jsx)("img", (0, $dPABA._)((0, $6ogO3._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});


parcelRegister("fl7Kz", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("92jF6")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("92jF6")).Card; });

var $92jF6 = parcelRequire("92jF6");

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2tb46 = parcelRequire("2tb46");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $2tb46.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("dWJQD", function(module, exports) {
$parcel$export(module.exports, "isTextComponent", function () { return $30fda6c6326a2078$export$4bf69398599dba31; });
$parcel$export(module.exports, "isAssetComponent", function () { return $30fda6c6326a2078$export$61be03ff0b6c6c6e; });
$parcel$export(module.exports, "isEmbedComponent", function () { return $30fda6c6326a2078$export$9846e8db24db36f4; });
$parcel$export(module.exports, "isProTipText", function () { return $30fda6c6326a2078$export$cfaa1a75f40e26f5; });
$parcel$export(module.exports, "isTwitterComponent", function () { return $30fda6c6326a2078$export$99fa2f2e7e0ad570; });
$parcel$export(module.exports, "isCallToAction", function () { return $30fda6c6326a2078$export$ab20f6e6e266a5a6; });
$parcel$export(module.exports, "isQuestionComponent", function () { return $30fda6c6326a2078$export$9c5fde415fc473c8; });
$parcel$export(module.exports, "isCallOutComponent", function () { return $30fda6c6326a2078$export$a58e7eebbfe3c431; });
const $30fda6c6326a2078$export$4bf69398599dba31 = (component)=>{
    return component.__typename === "ContentPlatformTextComponent" || component.__typename === "TextComponent";
};
const $30fda6c6326a2078$export$61be03ff0b6c6c6e = (component)=>{
    return component.__typename === "ContentPlatformAssetComponent" || component.__typename === "AssetComponent";
};
const $30fda6c6326a2078$export$9846e8db24db36f4 = (component)=>{
    return component.__typename === "ContentPlatformEmbeddedVideoAsset" || component.__typename === "EmbeddedVideoAsset";
};
const $30fda6c6326a2078$export$cfaa1a75f40e26f5 = (component)=>{
    return component.__typename === "ContentPlatformProTipComponent" || component.__typename === "ProTipComponent";
};
const $30fda6c6326a2078$export$99fa2f2e7e0ad570 = (component)=>{
    return component.__typename === "ContentPlatformTwitterComponent" || component.__typename === "TwitterComponent";
};
const $30fda6c6326a2078$export$ab20f6e6e266a5a6 = (component)=>{
    return component.__typename === "ContentPlatformCallToAction" || component.__typename === "CallToAction";
};
const $30fda6c6326a2078$export$9c5fde415fc473c8 = (component)=>{
    return component.__typename === "ContentPlatformQuestionComponent" || component.__typename === "QuestionComponent";
};
const $30fda6c6326a2078$export$a58e7eebbfe3c431 = (component)=>{
    return component.__typename === "ContentPlatformCallOutComponent" || component.__typename === "CallOutComponent";
};

});


var $b7P4C = parcelRequire("b7P4C");

var $6mvtm = parcelRequire("6mvtm");

var $3t7DW = parcelRequire("3t7DW");

var $hVRZ8 = parcelRequire("hVRZ8");
(0, $3t7DW.init)((0, $hVRZ8.AgileOverviewPage), (0, $b7P4C.AgileOverviewOneQuery), (0, $b7P4C.getAgileOverviewQueryVars)(window.location), (0, $6mvtm.RELAY_API_CONTENTFUL));


//# sourceMappingURL=agile-overview.aa8b4f60.js.map
